import workspace from "./workspace";

export const getMetricsToggle = async () => {
  try {
    const response = await workspace.get(`/metrics-toggle/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching metrics toggle:", error);
    throw error;
  }
};

export const createMetricsToggle = async (Data) => {
  try {
    const response = await workspace.post(`/metrics-toggle/`, Data);
    return response.data;
  } catch (error) {
    console.error(`Error updating with ID ${Id}:`, error);
    throw error;
  }
};

export const updateMetricsToggle = async (Id, Data) => {
  try {
    const response = await workspace.put(`/metrics-toggle/${Id}/`, Data);
    return response.data;
  } catch (error) {
    console.error(`Error updating with ID ${Id}:`, error);
    throw error;
  }
};